<div class="cookies">
  <div class="cookies-text">
    <p id="text-policy-cookies">
      {{ 'home-page.common.info-cookie' | translate }}
    </p>
  </div>

  <div class="cookies-panel">
    <button mat-stroked-button class="m-r-15 secondary" id="btn-reject-cookies" (click)="selectOpt('reject')">{{ 'home-page.common.reject-opt-cookie' | translate }}</button>
    <button mat-raised-button color="primary" id="btn-acept-cookies" (click)="selectOpt('acept')">{{'home-page.avail-search-occupancy.done-button-label' | translate}}</button>
  </div>

</div>





